/* app/lazyScreens.js — ленивые экраны разделов: каждый раздел — свой чанк, главный бандл несёт
   только оболочку, вход и маршрутизацию (kitchen-ux follow-up 30: index-*.js вырос до 3,1 МБ,
   первая загрузка вкладки на деве доходила до 30 с).

   ПРАВИЛО: экраны отсюда подключаются ТОЛЬКО динамическим import(). Статический импорт экрана
   (или модуля, который его тянет) в оболочку, провайдеры или routes.jsx вернёт раздел в главный
   чанк — сторож lazyScreens.test.js обходит статический граф от main.jsx и падает на этом.
   Вход (signin/signup/…) и короткие ссылки UTM остаются в главном чанке: это первый экран
   анонима, лишний запрос там дороже.

   screenForPath(pathname) — какой чанк нужен адресу. main.jsx качает его сразу, параллельно
   с /api/auth/me (иначе запрос чанка ждал бы ответа сессии); наведение и фокус на ссылке —
   заранее (installLinkPrefetch). Промах таблицы стоит только скорости: чанк всё равно придёт
   при рендере маршрута. */

import { lazyScreen } from './lazyScreen.js';

// ── рабочее пространство ──
export const ChatScreen = lazyScreen(() => import('../screens/workspace/ChatShell.jsx'), 'ChatScreen');
export const KitchenScreen = lazyScreen(() => import('../screens/kitchen/KitchenShell.jsx'), 'KitchenScreen');
// Аналитика — главный потребитель recharts: чарт-библиотека уезжает в чанк раздела
export const AnalyticsScreen = lazyScreen(() => import('../screens/analytics/Analytics.jsx'), 'AnalyticsScreen');
export const ReportsScreen = lazyScreen(() => import('../screens/reports/ReportsList.jsx'), 'ReportsScreen');
export const ReportDetailScreen = lazyScreen(() => import('../screens/reports/ReportDetail.jsx'), 'ReportDetailScreen');
export const SettingsScreen = lazyScreen(() => import('../screens/settings/SettingsScreen.jsx'), 'SettingsScreen');
export const NotificationsInbox = lazyScreen(() => import('../screens/notifications/NotificationsInbox.jsx'), 'NotificationsInbox');
export const UserSupportChat = lazyScreen(() => import('../screens/support/UserSupportChat.jsx'), 'UserSupportChat');
export const GiftBuy = lazyScreen(() => import('../screens/gift/GiftBuy.jsx'), 'GiftBuy');
export const GiftMy = lazyScreen(() => import('../screens/gift/GiftMy.jsx'), 'GiftMy');

// ── Академия: раздел ученика, консоль методиста, публичные страницы курса ──
export const LearningHome = lazyScreen(() => import('../screens/academy/LearningHome.jsx'), 'LearningHome');
export const CoursePlayer = lazyScreen(() => import('../screens/academy/CoursePlayer.jsx'), 'CoursePlayer');
export const CourseBuyPage = lazyScreen(() => import('../screens/academy/CourseBuyPage.jsx'), 'CourseBuyPage');
export const AcademyConsole = lazyScreen(() => import('../screens/academy/AcademyConsole.jsx'), 'AcademyConsole');
export const CourseLandingPage = lazyScreen(() => import('../screens/academy/landing/CourseLandingPage.jsx'), 'CourseLandingPage');
export const CoursePreviewPage = lazyScreen(() => import('../screens/academy/landing/CoursePreviewPage.jsx'), 'CoursePreviewPage');
export const CertificatePage = lazyScreen(() => import('../screens/academy/CertificatePage.jsx'), 'CertificatePage');

// ── Админка (staff) ──
export const AdminHub = lazyScreen(() => import('../screens/admin/AdminHub.jsx'), 'AdminHub');
export const CrmScreen = lazyScreen(() => import('../screens/crm/CrmShell.jsx'), 'CrmScreen');
export const CrmSettings = lazyScreen(() => import('../screens/crm/CrmSettings.jsx'), 'CrmSettings');
export const TrackerScreen = lazyScreen(() => import('../screens/tracker/TrackerScreen.jsx'), 'TrackerScreen');
export const BroadcastsScreen = lazyScreen(() => import('../screens/broadcasts/BroadcastsScreen.jsx'), 'BroadcastsScreen');
export const SupportScreen = lazyScreen(() => import('../screens/support/SupportScreen.jsx'), 'SupportScreen');
export const PlansScreen = lazyScreen(() => import('../screens/sales/PlansScreen.jsx'), 'PlansScreen');
export const PaymentLinksScreen = lazyScreen(() => import('../screens/sales/PaymentLinksScreen.jsx'), 'PaymentLinksScreen');
export const DealersScreen = lazyScreen(() => import('../screens/dealers/DealersScreen.jsx'), 'DealersScreen');
// UTM-метки — второй потребитель recharts (воронка в карточке метки)
export const UtmScreen = lazyScreen(() => import('../screens/utm/UtmScreen.jsx'), 'UtmScreen');
export const UtmTagDetail = lazyScreen(() => import('../screens/utm/UtmTagDetail.jsx'), 'UtmTagDetail');
export const UtmTypesScreen = lazyScreen(() => import('../screens/utm/UtmTypesScreen.jsx'), 'UtmTypesScreen');

// ── вне оболочки: оплата, подарок по ссылке, публичная поддержка, демо-стенд, витрина ──
export const PayByLink = lazyScreen(() => import('../screens/checkout/PayByLink.jsx'), 'PayByLink');
export const BuyPlan = lazyScreen(() => import('../screens/checkout/BuyPlan.jsx'), 'BuyPlan');
export const GiftRedeem = lazyScreen(() => import('../screens/gift/GiftRedeem.jsx'), 'GiftRedeem');
export const CheckoutMock = lazyScreen(() => import('../screens/checkout/CheckoutMock.jsx'), 'CheckoutMock');
export const CheckoutInvoice = lazyScreen(() => import('../screens/checkout/CheckoutInvoice.jsx'), 'CheckoutInvoice');
export const CheckoutSuccess = lazyScreen(() => import('../screens/checkout/CheckoutSuccess.jsx'), 'CheckoutSuccess');
export const CheckoutFail = lazyScreen(() => import('../screens/checkout/CheckoutFail.jsx'), 'CheckoutFail');
export const PublicSupport = lazyScreen(() => import('../screens/support/PublicSupport.jsx'), 'PublicSupport');
// оферта и политика — 58 КБ текста (legalContent.js): незачем каждому входу в приложение
export const LegalStub = lazyScreen(() => import('../screens/auth/LegalStub.jsx'), 'LegalStub');
// публичный демо-стенд бизнес-аналитики (/business-demo) — те же тяжёлые iiko-отчёты
export const BusinessDemoScreen = lazyScreen(() => import('../screens/demo/BusinessDemo.jsx'), 'BusinessDemo');
// dev-витрина UI-kit — показывает всё сразу (в т. ч. графики): только отдельным чанком
export const UiKit = lazyScreen(() => import('../screens/dev/UiKit.jsx'), 'UiKit');

/* Адрес → экраны, которые он отрисует (с учётом легаси-редиректов routes.jsx: /, /recipes,
   /dashboard, /ttk/…). Чистая функция — покрыта lazyScreens.test.js. */
function screenForPath(pathname) {
  const segs = String(pathname || '/').split('?')[0].split('/').filter(Boolean);
  const [a, b, c] = segs;
  switch (a) {
    case undefined: case 'chat': return [ChatScreen];
    case 'kitchen': case 'recipes': case 'products': case 'menu': case 'ttk': return [KitchenScreen];
    case 'analytics': case 'dashboard': return [AnalyticsScreen];
    case 'reports': return [b ? ReportDetailScreen : ReportsScreen];
    case 'settings': case 'account': case 'profile': case 'restaurant': return [SettingsScreen];
    case 'notifications': return [NotificationsInbox];
    case 'support': return [UserSupportChat];
    case 'learning':
      if (b === 'c') return [CoursePlayer];
      if (b === 'buy') return [CourseBuyPage];
      return [LearningHome];
    case 'course': return [CourseLandingPage];
    case 'certificate': return [CertificatePage];
    case 'academy': return [CoursePreviewPage];
    case 'gift':
      if (b === 'my') return [GiftMy];
      return b ? [GiftRedeem] : [GiftBuy];
    case 'pay': return [PayByLink];
    case 'buy': return [BuyPlan];
    case 'checkout':
      if (b === 'mock') return [CheckoutMock];
      if (b === 'invoice') return [CheckoutInvoice];
      if (b === 'success') return [CheckoutSuccess];
      if (b === 'fail') return [CheckoutFail];
      return [];
    case 'help': return [PublicSupport];
    case 'legal': return [LegalStub];
    case 'business-demo': return [BusinessDemoScreen];
    case 'dev': return b === 'uikit' ? [UiKit] : [];
    case 'crm': return [CrmScreen];
    case 'console':
      if (b === undefined) return [AdminHub];
      if (b === 'crm') return [c === 'settings' ? CrmSettings : CrmScreen];
      if (b === 'broadcasts') return [BroadcastsScreen];
      if (b === 'tasks') return [TrackerScreen];
      if (b === 'support') return [SupportScreen];
      if (b === 'plans') return [PlansScreen];
      if (b === 'payment-links') return [PaymentLinksScreen];
      if (b === 'dealers') return [DealersScreen];
      if (b === 'academy') return [AcademyConsole];
      if (b === 'utm') return [c === 'types' ? UtmTypesScreen : c ? UtmTagDetail : UtmScreen];
      return [];
    default: return [];
  }
}

function preloadScreenFor(pathname) {
  screenForPath(pathname).forEach((screen) => { screen.preload(); });
}

/* Предзагрузка по намерению: наведение, фокус или касание ссылки своего сайта (сайдбар,
   таб-бар, крошки, ссылки в карточках) — чанк её раздела качается до клика. Один делегированный
   слушатель на документ, компоненты навигации не трогаем. */
function installLinkPrefetch(doc = typeof document !== 'undefined' ? document : null) {
  if (!doc || typeof doc.addEventListener !== 'function') return () => {};
  const onIntent = (e) => {
    const t = e.target;
    const a = t && typeof t.closest === 'function' ? t.closest('a[href]') : null;
    if (!a) return;
    let url;
    try { url = new URL(a.href, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin) return;
    preloadScreenFor(url.pathname);
  };
  const opts = { passive: true };
  doc.addEventListener('mouseover', onIntent, opts);
  doc.addEventListener('focusin', onIntent);
  doc.addEventListener('touchstart', onIntent, opts);
  return () => {
    doc.removeEventListener('mouseover', onIntent, opts);
    doc.removeEventListener('focusin', onIntent);
    doc.removeEventListener('touchstart', onIntent, opts);
  };
}

export { screenForPath, preloadScreenFor, installLinkPrefetch };
